import { HomeLoanCalculatorConfig } from "../../../types";
import { APIRequest, APIRequestMethod } from "../APIRequest";
import { Client } from "../Client";

class CalculatorAPI {
  GetHomeLoanConfig(): Promise<HomeLoanCalculatorConfig> {
    return Client.Request(new APIRequest(APIRequestMethod.GET, '/api/calculators/home_loan/config'));
  }
}

export { CalculatorAPI }